import { snakeCase } from 'lodash'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { Field } from './types'

export default function useRequiredFormField() {
  const translate = useTranslate()

  return function requiredField(field: Field) {
    const fieldName = translate(
      `conversation.conversation_info.cancel_transaction_modal.fields.${snakeCase(field)}.title`,
    )

    return {
      value: true,
      message: translate('errors.blank', { field: fieldName }),
    }
  }
}
